//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import isMobile from "~/mixins/isMobile.js";
import {
  stateNameByValue,
  stateAbbreviationByValue,
  states,
} from "@/src/states";

export default {
  mixins: [isMobile],
  props: {
    data: {
      required: true,
    },
    links: {
      required: true,
    },
    cta: {
      required: true,
    },
    customText: {
      required: false,
    },
    is_previewable: {
      required: false,
    },
    preview: {
      required: false,
    },
    isDesignTestV3: {
      required: false,
      default: false,
    },
    isOrder: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isDoubleQuote: false,
      localPreview: "",
      isFullPreview: false,
      selectedState: null,
      hide: false,
    };
  },
  created() {
    if (!process.server) this.localPreview = this.decodeHtml(this.preview);
  },
  computed: {
    mainDescription() {
      let match = this.data.table.subtitle.match(/[^.]+\./);
      return match ? match[0] : "";
    },

    secondDescription() {
      let description = this.data.table.subtitle
        .replace(this.mainDescription, "")
        .trim();
      if (description)
        if (description[0] !== '"') return description;
        else {
          this.isDoubleQuote = true;
          return description.substring(1);
        }
    },

    productDescription() {
      return this.data.table.subtitle.split(/.(.+)/s);
    },
    product() {
      return this.$route.params.product_slug;
    },
  },
  methods: {
    options() {
      return states.map(function(s) {
        return {
          value: s.value,
          text: s.label,
        };
      });
    },
    stateAbbreviationByValue(stateId) {
      return stateAbbreviationByValue(stateId);
    },
    stateNameByValue(stateId) {
      return stateNameByValue(stateId);
    },
    stateSelect(event) {
      this.stateID = event.target.value;
      this.state = this.stateNameByValue(this.stateID);
    },
    decodeHtml(html) {
      if (document) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
      }
    },
    handlePreview() {
      if (this.isFullPreview) this.isFullPreview = false;
      else this.isFullPreview = true;
    },
  },
};
